<template>
  <ReportBaseSelectFilter
    class="changed-by-filter"
    label="Changed by"
    placeholder="All members"
    :options="options"
    query-property="created_by"
  />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ReportChangedByFilter',
  computed: {
    options() {
      return this.allChangedByMembers.map((member) => {
        return {
          id: member[0],
          text: member[1],
        };
      });
    },
    ...mapGetters(['allChangedByMembers']),
  },
};
</script>
